import { EffectCallback, DependencyList, useEffect, useRef } from 'react';

export function useDidMountEffect(
  effect: EffectCallback,
  deps?: DependencyList,
) {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) return effect();
    else didMount.current = true;
  }, deps);
}
